<template>
  <div class="shared-legend">
    <div
      v-for="(item, index) in legendItems"
      :key="index"
      class="legend-item"
      :class="{ hidden: item.hidden }"
      @click="toggle(item, index)"
    >
      <span
        class="legend-color"
        :style="{ backgroundColor: item.fillStyle }"
      />
      <span class="legend-label">{{ item.text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SharedLegend',

  props: {
    charts: {
      type: Array,
      default: () => []
    },
    // 'segment' — doughnut/pie (легенда по labels/сегментам)
    // 'dataset' — bar (легенда по датасетам)
    mode: {
      type: String,
      default: 'segment' // 'segment' | 'dataset'
    }
  },

  data() {
    return {
      tick: 0,
      hiddenIndices: {}
    }
  },

  computed: {
    legendItems() {
      this.tick

      const chart = this.charts.find(c => c)
      if (!chart || !chart.data) return []

      if (this.mode === 'dataset') {
        // Bar+Bar — строим по датасетам
        const datasets = chart.data.datasets
        if (!datasets || !datasets.length) return []

        return datasets.map((ds, index) => ({
          text: ds.label || `Dataset ${index + 1}`,
          fillStyle: Array.isArray(ds.backgroundColor)
            ? ds.backgroundColor[0]
            : ds.backgroundColor,
          hidden: !!this.hiddenIndices[index],
          index
        }))

      } else {
        // Doughnut+Bar — строим по labels/сегментам
        const { labels } = chart.data
        if (!labels || !labels.length) return []

        const dataset = chart.data.datasets[0]
        if (!dataset) return []

        const colors = Array.isArray(dataset.backgroundColor)
          ? dataset.backgroundColor
          : labels.map(() => dataset.backgroundColor)

        return labels.map((label, index) => ({
          text: label,
          fillStyle: colors[index] || '#ccc',
          hidden: !!this.hiddenIndices[index],
          index
        }))
      }
    }
  },

  methods: {
    toggle(item, index) {
      this.$set(this.hiddenIndices, index, !this.hiddenIndices[index])
      const isHidden = this.hiddenIndices[index]

      this.charts.forEach(chart => {
        if (!chart) return
        const type = chart.config.type

        if (this.mode === 'dataset') {
          // Bar+Bar — скрываем датасет по индексу
          const meta = chart.getDatasetMeta(index)
          if (meta) meta.hidden = isHidden || false

        } else {
          // Doughnut — скрываем сегмент
          if (type === 'doughnut' || type === 'pie') {
            const meta = chart.getDatasetMeta(0)
            if (meta && meta.data && meta.data[index]) {
              meta.data[index].hidden = isHidden || false
            }
          } else {
            // Bar рядом с doughnut — скрываем датасет
            const meta = chart.getDatasetMeta(index)
            if (meta) meta.hidden = isHidden || false
          }
        }

        chart.update()
      })

      this.tick++
    }
  }
}
</script>

<style scoped>
.shared-legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px 24px;
  margin-top: 16px;
}
.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
  transition: opacity 0.2s;
}
.legend-item.hidden {
  opacity: 0.35;
}
.legend-color {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 2px;
  flex-shrink: 0;
}
.legend-label {
  font-size: 13px;
  color: #494f59;
}
</style>